import React from "react";
import { useNavigate } from "react-router-dom";
import BaseAgentTable from "@/components/agent/BaseAgentTable";
import { routes } from "@/configs/router.config/routes";
import { useCommandMutations } from "@/hooks/agent/useCommandMutations";
import { useCommands } from "@/hooks/agent/useCommands";
import { useWorkspaces } from "@/hooks/useWorkspaces";

const CommandsTable: React.FC = () => {
  const navigate = useNavigate();
  const { sessionCurrentWorkspaceId } = useWorkspaces();
  const { deleteCommand } = useCommandMutations();

  // enabled=false も含めて全て取得
  const { commands, isLoading, mutate } = useCommands(sessionCurrentWorkspaceId || null, false);

  const handleDelete = async (itemId: string, itemName: string) => {
    await deleteCommand(itemId, itemName);
    mutate();
  };

  return (
    <BaseAgentTable
      items={commands}
      loading={isLoading}
      onEdit={(commandId) => navigate(routes.editCommand(sessionCurrentWorkspaceId)(commandId))}
      handleDelete={handleDelete}
    />
  );
};

export default CommandsTable;
